import React from 'react';
import Helmet from 'react-helmet';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

/*
  In iOS, Smart App Banners provide a consistent look and feel that users come to recognize
  https://developer.apple.com/documentation/webkit/promoting_apps_with_smart_app_banners#3701576
 */
const SmartBannerIosMetaTag = () => {
  const { mary175DownloadBanner } = useLDFlags();
  if (mary175DownloadBanner) {
    return (
      <Helmet>
        <meta
          content={`app-id=1464601606, app-argument=${window?.location?.href}`}
          name="apple-itunes-app"
        />
      </Helmet>
    );
  }
  return null;
};

export default SmartBannerIosMetaTag;
